import React from 'react';


const ResultTable = ({data}) => {


    return <table className="calculator-results">
        <thead>
        <tr>
            <th className="rotate">Year</th>
            <th className="rotate">Annual Energy Savings</th>
            <th className="rotate">Capital Cost</th>
            <th className="rotate">O&m Cost</th>
            <th className="rotate">Other Costs</th>
            <th className="rotate">Total annual costs</th>
            <th className="rotate">Net cashflow</th>
            <th className="rotate">Net cashflow cumulated</th>
            <th className="rotate">Discount factor</th>
            <th>Discount cashflow</th>
            <th>Discount cashflow cumulated</th>
            <th>Present value</th>
        </tr>
        </thead>
        <tbody>

        {data.map(({
                       year,
                       capitalCost,
                       annualEnergySavings,
                       operationalCosts,
                       otherCosts,
                       totalAnnualCosts,
                       netCf,
                       discountFactor,
                       discountedCf,
                       netCfCumulated,
                       discountedCfCumulated,
                   }) => <tr key={year}>
            <td>{year}</td>
            <td>{annualEnergySavings && annualEnergySavings.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
            <td>{capitalCost}</td>
            <td>{operationalCosts && operationalCosts.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
            <td>{otherCosts && otherCosts.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
            <td>{totalAnnualCosts && totalAnnualCosts.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
            <td>{netCf && netCf.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
            <td>{netCfCumulated && netCfCumulated.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
            <td>{discountFactor && discountFactor.toLocaleString(undefined, {
                maximumFractionDigits: 4,
                minimumFractionDigits: 4
            })}</td>
            <td>{discountedCf && discountedCf.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
            <td>{discountedCfCumulated && discountedCfCumulated.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
            <td>{discountedCf && discountedCf.toLocaleString(undefined, {maximumFractionDigits: 0})}</td>
        </tr>)}
        </tbody>
    </table>
};


export default ResultTable;
